import React, {useState, useEffect, useRef} from 'react';
import {useNavigate, useParams} from "react-router-dom";
import {withTranslation} from 'react-i18next';
import {DataTable} from 'primereact/datatable';
import {Column} from 'primereact/column';
import {Button} from "primereact/button";
import {Dropdown} from "primereact/dropdown";
import {ConfirmDialog} from "primereact/confirmdialog";
import {addLocale, locale} from "primereact/api";
import {InputText} from "primereact/inputtext";
import {Badge} from "primereact/badge";
import moment from "moment";
import download from "js-file-download";
import axios from "axios";
import Cookies from "js-cookie";

import HelpComponent from "../HelpComponent";
import currencyFormatter from "currency-formatter";

const _FM_ReceiptListComponent = (props) => {
  const {t} = props;
  const navigate = useNavigate();
  const {entity, action, id} = useParams();
  const [receipt, setReceipt] = useState([]);
  const [loading, setLoading] = useState(false);
  const [totalRecords, setTotalRecords] = useState(0);
  const [rows, setRows] = useState(10);
  const dt = useRef(null);
  const filterTextMatchModes = [
    {label: t('filter_like'), value: 'like'},
    {label: t('filter_equals'), value: '='},
    {label: t('filter_not_equals'), value: '!='},
  ]
  const filterNumberMatchModes = [
    {label: t('filter_between_number'), value: 'between'},
    {label: t('filter_equals'), value: '='},
    {label: t('filter_not_equals'), value: '!='},
    {label: t('filter_greather_than'), value: '>'},
    {label: t('filter_greather_than_or_equals'), value: '>='},
    {label: t('filter_less_than'), value: '<'},
    {label: t('filter_less_than_or_equals'), value: '<='},
  ]
  const filterDateMatchModes = [
    {label: t('filter_between_date'), value: 'between'},
    {label: t('filter_equals'), value: '='},
    {label: t('filter_not_equals'), value: '!='},
    {label: t('filter_greather_than'), value: '>'},
    {label: t('filter_greather_than_or_equals'), value: '>='},
    {label: t('filter_less_than'), value: '<'},
    {label: t('filter_less_than_or_equals'), value: '<='},
  ]
  const [lazyParams, setLazyParams] = useState({
    first: Number(localStorage.getItem('receipt_first')) || 0,
    rows: Number(localStorage.getItem('receipt_rows')) || rows,
    page: Number(localStorage.getItem('receipt_page')) || 0,
    sortField: localStorage.getItem('receipt_sortField') || 'id',
    sortOrder: Number(localStorage.getItem('receipt_sortOrder')) || -1,
    filters: JSON.parse(localStorage.getItem('receipt_filters')) || null,
  });
  let loadLazyTimeout = null;
  const loadLazyData = () => {
    setLoading(true);
    if (loadLazyTimeout) {
      clearTimeout(loadLazyTimeout);
    }
    loadLazyTimeout = setTimeout(() => {
      let query = window.App.transformQueryParams(lazyParams)
      if (props.groupId) {
        query += '&search[reservation_group][operator]=%3D&search[reservation_group][value]=' + encodeURIComponent(props.groupId)
      }
      axios({
        method: 'get',
        url: process.env.REACT_APP_API_PROTOCOL + process.env.REACT_APP_API_HOST + "invoice" + query,
        params: {},
        headers: {
          'Authorization': 'Bearer ' + Cookies.get("userToken"),
          "Sys-name": Cookies.get("instanceId"),
          "Preferred-locale": Cookies.get("language")
        }
      })
        .then(response => {
          setTotalRecords(response.data.data.total_item_count);
          setReceipt(response.data.data.items);
          setLoading(false);
        })
        .catch(error => {
          setLoading(false)
          window.App.toastShow('error', t('error'), error.toString(), '', error.response);
        })
    }, Math.random() * 1000 + 250);
  }
  const onPage = (event) => {
    let _lazyParams = {...lazyParams, ...event};
    setLazyParams(_lazyParams);
  }
  const onSort = (event) => {
    let _lazyParams = {...lazyParams, ...event};
    setLazyParams(_lazyParams);
  }
  const onFilter = (event) => {
    let _lazyParams = {...lazyParams, ...event};
    _lazyParams['first'] = 0;
    _lazyParams['page'] = 0;
    setLazyParams(_lazyParams);
  }
  const pager = {
    layout: 'RowsPerPageDropdown CurrentPageReport PrevPageLink NextPageLink',
    'RowsPerPageDropdown': (options) => {
      const dropdownOptions = [
        {label: 10, value: 10},
        {label: 20, value: 20},
        {label: 50, value: 50},
        {label: 200, value: 200}
      ];

      return (
        <>
          {/*<span className="p-mx-1" style={{color: 'var(--text-color)', receiptSelect: 'none'}}>Tételek egy oldalon: </span>*/}
          <Dropdown value={options.value} options={dropdownOptions} onChange={(e) => setRows(e.target.value)}
                    />
        </>
      );
    },
    'CurrentPageReport': (options) => {
      return (
        <span style={{color: 'var(--text-color)', receiptSelect: 'none', width: '120px', textAlign: 'center'}}>
                        {options.first} - {options.last} / {options.totalRecords}
        </span>
      )
    }
  };

  const actionBodyTemplate = (rowData) => {
    return (
      <React.Fragment>
        {rowData?.type === 'proforma' && rowData?.status === 'issued' && rowData?.paid_at === null ? (
          <Button icon="pi pi-check" className="p-button-sm p-button-success p-ml-2"
                  tooltip={t('mark_as_paid')}
                  loading={loading}
                  tooltipOptions={{position: 'left'}}
                  onClick={() => {
                    axios.post(process.env.REACT_APP_API_PROTOCOL + process.env.REACT_APP_API_HOST + "invoice/" + rowData.id + "/mark-paid",
                      {},
                      {
                        params: {},
                        headers: {
                          'Authorization': 'Bearer ' + Cookies.get("userToken"),
                          "Sys-name": Cookies.get("instanceId"),
                          "Preferred-locale": Cookies.get("language"),
                          'Content-Type': 'multipart/form-data'
                        }
                      })
                      .then(response => {
                        window.App.setState({
                          rerenderReceiptList: Math.random(),
                        })
                      })
                      .catch(error => {
                        window.App.toastShow('error', t('error'), error.toString(), '', error.response);
                      })
                  }}
          />
        ) : (
          <Button icon="pi pi-check" className="p-button-sm p-button-success p-ml-2"
                  tooltip={t('mark_as_paid')}
                  disabled
                  loading={loading}
                  tooltipOptions={{position: 'left'}}
          />
        )}
        {rowData?.billing_integration && rowData?.billing_integration !== 'none' ? (
          <Button icon="pi pi-download" className="p-button-sm p-button-secondary p-ml-2"
                  tooltip={t('download')}
                  disabled={!rowData.pdf_url}
                  loading={loading}
                  tooltipOptions={{position: 'left'}}
                  onClick={() => {
                    if (rowData?.billing_integration === 'Billingo') {
                      window.open(rowData.pdf_url, '_blank', 'noopener,noreferrer');
                    }
                    if (rowData?.billing_integration === 'számlázz.hu' || rowData?.billing_integration === 'szamlazz.hu') {
                      axios.get(process.env.REACT_APP_API_PROTOCOL + process.env.REACT_APP_API_HOST + 'billing/invoice/' + rowData.id + '/download-pdf',
                        {
                          responseType: 'blob',
                          params: {},
                          headers: {
                            'Authorization': 'Bearer ' + Cookies.get("userToken"),
                            "Sys-name": Cookies.get("instanceId"),
                            "Preferred-locale": Cookies.get("language"),
                          }
                        })
                        .then(response => {
                          window.App.toastShow('success', t('success'), response.data.message)
                          download(response.data, rowData.third_party_service_id + '.pdf')
                        })
                        .catch(error => {
                          window.App.toastShow('error', t('error'), error.toString(), '', error.response);
                        })
                    }
                  }}
          />
        ) : (
          <Button icon="pi pi-download" className="p-button-sm p-button-secondary p-ml-2"
                  tooltip={t('download')}
                  disabled
                  loading={loading}
                  tooltipOptions={{position: 'left'}}
          />
        )}
        {/*{!props.groupId &&*/}
        {/*  <>*/}
        <Button icon="pi pi-eye" className="p-button-sm p-button-secondary p-ml-2"
                tooltip={t('show')}
                tooltipOptions={{position: 'left'}}
                onClick={() => {
                  if (window.location.hash.toString().includes('#/receipt')) {
                    navigate('/receipt/read/' + rowData.id)
                  }
                  if (window.location.hash.toString().includes('#/reservation')) {
                    navigate('/reservation/' + action + '/' + id + "?read=invoice&invoiceId=" + rowData.id)
                  }
                  if (window.location.hash.toString().includes('#/calendar')) {
                    navigate('/calendar/' + action + '/' + id + "?read=invoice&invoiceId=" + rowData.id)
                  }
                }}/>
        {rowData.status === 'draft' ? (
          <Button icon="pi pi-pencil" className="p-button-sm  p-button-warning p-ml-2"
                  tooltip={t('edit')}
                  tooltipOptions={{position: 'left'}}
                  onClick={() => {
                    if (window.location.hash.toString().includes('#/receipt')) {
                      navigate('/receipt/update/' + rowData.id)
                    }
                    if (window.location.hash.toString().includes('#/reservation')) {
                      navigate('/reservation/' + action + '/' + id + "?update=invoice&invoiceId=" + rowData.id)
                    }
                    if (window.location.hash.toString().includes('#/calendar')) {
                      navigate('/calendar/' + action + '/' + id + "?update=invoice&invoiceId=" + rowData.id)
                    }
                  }}/>
        ) : (
          <>
            <Button icon="pi pi-times" className="p-button-sm p-button-danger p-ml-2"
                    tooltip={t('receipt_cancel')}
                    loading={loading}
                    tooltipOptions={{position: 'left'}}
                    disabled={rowData.status === 'cancelled'}
                    onClick={() => {
                      window.App.setState({[`confirmReceiptCancel${rowData.id}`]: true})
                    }}
            />
            <ConfirmDialog group="declarative" visible={window.App.state[`confirmReceiptCancel${rowData.id}`]}
                           acceptLabel={t('yes')} rejectLabel={t('no')}
                           onHide={() => {
                             window.App.setState({[`confirmReceiptCancel${rowData.id}`]: false})
                           }}
                           message={t('confirm_receipt_cancel_message')}
                           header={t('receipt_cancel')}
                           icon="pi pi-exclamation-triangle"
                           accept={() => {
                             setLoading(true);
                             if (rowData?.billing_integration === 'számlázz.hu') {
                               axios.post(process.env.REACT_APP_API_PROTOCOL + process.env.REACT_APP_API_HOST + "billing/invoice/" + rowData.id + "/cancel-szamlazzhu",
                                 rowData,
                                 {
                                   params: {},
                                   headers: {
                                     'Authorization': 'Bearer ' + Cookies.get("userToken"),
                                     "Sys-name": Cookies.get("instanceId"),
                                     "Preferred-locale": Cookies.get("language")
                                   }
                                 })
                                 .then(response => {
                                   loadLazyData()
                                 })
                                 .catch(error => {
                                   window.App.toastShow('error', t('error'), error.toString(), '', error.response);
                                   setLoading(false);
                                 })
                             }
                             if (rowData?.billing_integration === 'Billingo') {
                               axios.post(process.env.REACT_APP_API_PROTOCOL + process.env.REACT_APP_API_HOST + "billing/invoice/" + rowData.id + "/cancel-billingo",
                                 rowData,
                                 {
                                   params: {},
                                   headers: {
                                     'Authorization': 'Bearer ' + Cookies.get("userToken"),
                                     "Sys-name": Cookies.get("instanceId"),
                                     "Preferred-locale": Cookies.get("language")
                                   }
                                 })
                                 .then(response => {
                                   loadLazyData()
                                 })
                                 .catch(error => {
                                   window.App.toastShow('error', t('error'), error.toString(), '', error.response);
                                   setLoading(false);
                                 })
                             }
                           }}
                           reject={() => {
                             window.App.setState({[`confirmReceiptCancel${rowData.id}`]: false})
                           }}/>
          </>
        )}
        {/*  </>*/}
        {/*}*/}
      </React.Fragment>
    );
  }

  addLocale('default', {
    clear: t('filter_clear'),
    apply: t('filter_apply'),
  });
  locale('default');

  useEffect(() => {
    if (lazyParams.filters) {
      document.getElementById('search').value = '';
      localStorage.setItem('receipt_filters', JSON.stringify(lazyParams.filters))
      if (lazyParams.sortField) {
        localStorage.setItem('receipt_sortField', lazyParams.sortField)
      }
      if (lazyParams.sortOrder) {
        localStorage.setItem('receipt_sortOrder', lazyParams.sortOrder)
      }
      if (lazyParams.first >= 0) {
        localStorage.setItem('receipt_first', lazyParams.first)
      }
      if (lazyParams.page >= 0) {
        localStorage.setItem('receipt_page', lazyParams.page)
      }
      if (lazyParams.rows) {
        localStorage.setItem('receipt_rows', lazyParams.rows)
        setRows(lazyParams.rows)
      }
    }
    loadLazyData();
  }, [lazyParams, window.App.state.rerenderReceiptList])

  return (
    <>
      <div className={"p-grid"}>
        <div className={"p-col-12 p-lg-4 p-col-align-center"}>
          <h2 className={"p-m-0"}>{t('receipt_list')}</h2>
        </div>
        <div className={"p-col-12 p-lg-8 p-text-right p-col-align-center"}>
          <HelpComponent type={"site"} position={"UNDER_HELP_BUTTON"}/>
          {localStorage.getItem('receipt_filters') &&
            <a style={{color: "red"}} className={"p-button p-button-danger p-ml-2"}
               onClick={() => {
                 localStorage.removeItem('receipt_filters')
                 localStorage.removeItem('receipt_sortField')
                 localStorage.removeItem('receipt_sortOrder')
                 localStorage.removeItem('receipt_rows')
                 localStorage.removeItem('receipt_page')
                 localStorage.removeItem('receipt_first')
                 setLazyParams({
                   ...lazyParams,
                   filters: null
                 })
               }}
            >
              <i className={"pi pi-exclamation-triangle"}></i>&nbsp;{t('clear_filter')}
            </a>
          }
          {lazyParams && lazyParams.is_active === 0 ? (
            <Button type="button" icon={"pi pi-eye-slash"}
                    label={t('hide_deleted')}
                    onClick={() => {
                      let _lazyParams = lazyParams
                      delete lazyParams.is_active
                      setLazyParams(_lazyParams)
                      loadLazyData()
                    }}
                    className="p-button-danger p-ml-2"/>
          ) : (
            <Button type="button" icon={"pi pi-eye"}
                    label={t('show_deleted')}
                    onClick={() => {
                      setLazyParams({
                        ...lazyParams,
                        is_active: 0
                      })
                    }}
                    className="p-button-success p-ml-2"/>
          )}
          <span className="p-input-icon-left p-ml-2">
              <i className="pi pi-search"/>
              <InputText id="search"
                         placeholder={t('search')}
                         onChange={(e) => {
                           clearTimeout(window.searchTimeout)
                           window.searchTimeout = setTimeout(function () {
                             localStorage.removeItem('receipt_filters')
                             localStorage.removeItem('receipt_sortField')
                             localStorage.removeItem('receipt_sortOrder')
                             localStorage.removeItem('receipt_rows')
                             localStorage.removeItem('receipt_page')
                             localStorage.removeItem('receipt_first')
                             setLazyParams({
                               ...lazyParams,
                               genericSearch: e.target.value,
                               filters: null
                             })
                           }, 1000)
                         }}
                         className={""}
              />
            </span>
        </div>
      </div>
      {/* <HelpComponent type={"list_box"} box={"invoice"}/> */}
      <DataTable
        ref={dt}
        size={"small"}
        emptyMessage={t('empty_message')}
        value={receipt} paginator first={lazyParams.first} totalRecords={totalRecords} onPage={onPage}
        onSort={onSort} sortField={lazyParams.sortField} sortOrder={lazyParams.sortOrder}
        onFilter={onFilter} filters={lazyParams.filters} loading={loading} lazy
        paginatorTemplate={pager} rows={rows}
        autoLayout={true}
        filterDisplay="menu"
        responsiveLayout={window.App.state.responsiveLayout}
        breakpoint="1365px"
        stripedRows
        dataKey="id"
        selectionMode={"single"}
        onRowDoubleClick={(rowData) => {
          if (!rowData.data.deleted_at_snapshot)
            if (window.location.hash.includes('#/receipt/')) {
              navigate('/receipt/update/' + rowData.data.id)
            }
        }}
      >
        <Column className={"p-d-relative"} style={{position: 'relative', width: '10px', maxWidth: '10px'}}
                body={(rowData) => {
                  let _color = '#fff';
                  if (rowData.status === 'draft') {
                    _color = '#ffb027';
                  }
                  if (rowData.status === 'issued') {
                    _color = '#0abb87';
                  }
                  if (rowData.status === 'cancelled') {
                    _color = '#ff7f7f';
                  }
                  return (
                    <>
                          <span style={{
                            position: 'absolute',
                            left: '0',
                            top: '0',
                            height: '100%',
                            borderLeft: '10px solid ' + _color,
                          }}></span>
                    </>
                  )
                }}/>
        <Column field="status" header={t('status')}
                body={(rowData) => {
                  let _color = '#fff';
                  let _label = '';
                  if (rowData.status === 'draft') {
                    _color = '#ffb027';
                    _label = t('receipt_status_draft');
                  }
                  if (rowData.status === 'issued') {
                    _color = '#0abb87';
                    if(rowData.type === 'proforma') {
                      _label = t('receipt_status_proforma');
                    } else {
                      _label = t('receipt_status_issued');
                    }

                  }
                  if (rowData.status === 'cancelled') {
                    _color = '#ff7f7f';
                    _label = t('receipt_status_cancelled');
                  }
                  return (
                    <Badge value={_label} style={{backgroundColor: _color, color: '#fff'}} className={"p-d-block"}/>
                  )
                }}
        ></Column>
        <Column field="third_party_service_id" sortable header={t('external_number')}
                filter
                filterMatchMode="like"
                filterMatchModeOptions={filterTextMatchModes}
        ></Column>
        <Column field="issued_at" sortable header={t('issued_at')}
                filter
                filterMatchMode="between"
                filterMatchModeOptions={filterDateMatchModes}
                body={(rowData) => {
                  if (rowData.issued_at !== null) {
                    return (
                      <span>{moment.utc(rowData.issued_at).local().format(t('YYYY-MM-DD'))}</span>
                    )
                  }
                }}></Column>
        <Column field="fulfillment_date" sortable header={t('fulfillment_date')}
                filter
                filterMatchMode="between"
                filterMatchModeOptions={filterDateMatchModes}
                body={(rowData) => {
                  if (rowData.fulfillment_date !== null) {
                    return (
                      <span>{moment.utc(rowData.fulfillment_date).local().format(t('YYYY-MM-DD'))}</span>
                    )
                  }
                }}></Column>
        {!props.groupId &&
          <Column sortable header={t('reservation') + " / " + t('customer')}
                  className={"p-text-nowrap"}
                  body={(rowData) => {
                    return (
                      <>
                        {rowData?.customer?.id &&
                          <>
                            <i className={"pi pi-window-maximize"}
                               onClick={(e) => {
                                 e.stopPropagation();
                                 navigate('/receipt?read=customer&customerId=' + rowData?.customer?.id)
                               }}
                            ></i>
                            &nbsp;
                            {rowData?.customer?.firstname} {rowData?.customer?.lastname}
                          </>
                        }
                        {rowData?.reservation_group?.id &&
                          <>
                            <i className={"pi pi-window-maximize"}
                               onClick={(e) => {
                                 e.stopPropagation();
                                 navigate('/receipt?read=reservationGroup&reservationGroupId=' + rowData.reservation_group?.id)
                               }}
                            ></i>
                            &nbsp;
                            {rowData.reservation_group?.public_id?.toUpperCase()}
                          </>
                        }
                        {!rowData?.customer?.id && !rowData?.reservation_group?.id && '-'}
                      </>
                    )
                  }}
          ></Column>
        }
        {!props.groupId &&
          <Column field="buyer_name" sortable header={t('buyer')}
                  filter
                  filterMatchMode="like"
                  filterMatchModeOptions={filterTextMatchModes}
          ></Column>
        }
        {!props.groupId &&
          <Column field="buyer_tax_number" sortable header={t('buyer_tax_number')}
                  filter
                  filterMatchMode="like"
                  filterMatchModeOptions={filterTextMatchModes}
          ></Column>
        }
        <Column field="gross_amount" sortable header={t('gross_amount')}
                filter
                filterMatchMode="like"
                filterMatchModeOptions={filterTextMatchModes}
                className={"p-text-right p-text-nowrap"}
                body={(rowData) => {
                  return (
                    <>
                      {currencyFormatter.format(
                        rowData.gross_amount, {
                          precision: t('currency_precision'),
                          symbol: t('currency_symbol'),
                          decimal: t('currency_decimal'),
                          thousand: t('currency_thousand'),
                        }
                      )} {rowData.currency}
                    </>
                  )
                }}
        ></Column>
        {!props.groupId &&
          <Column field="type" sortable header={t('type')}
                  filter
                  filterMatchMode="like"
                  filterMatchModeOptions={filterTextMatchModes}
                  body={(rowData) => (
                    <>
                      {t('receipt_' + rowData.type)}
                    </>
                  )}
          ></Column>
        }
        <Column field="paid_at" sortable header={t('paid_at')}
                body={(rowData) => {
                  if (rowData.paid_at !== null) {
                    return (
                      <Badge value={t('paid')} style={{backgroundColor: '#0abb87', color: '#fff'}}
                             className={"p-d-block"}/>
                    )
                  } else {
                    return (
                      <Badge value={t('unpaid')} style={{backgroundColor: '#ffb027', color: '#fff'}}
                             className={"p-d-block"}/>
                    )
                  }
                }}></Column>
        <Column body={actionBodyTemplate} className={"p-py-0 p-text-nowrap p-text-right"}></Column>
      </DataTable>
    </>
  )
}
export default withTranslation('common')(_FM_ReceiptListComponent);
